
let rushingDictionary = {
    "playerName":"NAME", 
    "playerClass":"CLASS", 
    "position":"POS", 
    "actualDate":"DATE", 
    "academicSeason":"SEASON", 
    "teamName":"TEAM", 
    "opponentTeamName":"OPP", 
    "gameResult":"RES", 
    "total":"TOTAL"
}



const rushingColumns = [
    "playerName",
    "playerClass",
    "position",
    "actualDate",
    "academicSeason",
    "teamName",
    "opponentTeamName",
    "gameResult",
    "total",
] as const;

const newRushingColumns = [
    "PLAYER",
    "CLASS",
    "POS",
    "DATE",
    "SEASON",
    "TEAM",
    "OPP",
    "RES",
    "TOTAL",
]

export function filterAndReplaceColumnNames<T extends Record<string, any>>(
    arr: T[]
): Record<string, any>[] {
    return arr.map((obj, index) => {
        const filteredAndRenamedObj: Record<string, any> = {
            ID: index + 1, // added ID starting from 1
        };

        // filtering columns
        rushingColumns.forEach((key) => {
            if (key in obj) {
                //renaming
                const newKey = rushingDictionary[key as keyof typeof rushingDictionary];
                filteredAndRenamedObj[newKey] = obj[key];
            }
        });

        //adding 
        if (obj.stats && typeof obj.stats === "object") {
            Object.entries(obj.stats).forEach(([statKey, statValue]) => {
              filteredAndRenamedObj[statKey.toUpperCase()] = statValue; // Use uppercase for consistency
            });
          }

        return filteredAndRenamedObj;
    });
}


// export function filterCols<T extends Record<string, any>>(
//     arr: T[]
// ): Record<string, any>[] {
//     return arr.map((obj, index) => {
//         const filteredAndRenamedObj: Record<string, any> = {
//             ID: index + 1,
//         };

//         newRushingColumns.forEach((key) => {
//             if (key in obj) {
//                 filteredAndRenamedObj[key] = obj[key];
//             }
//         });

//         if (obj.stats && typeof obj.stats === "object") {
//             Object.entries(obj.stats).forEach(([statKey, statValue]) => {
//                 filteredAndRenamedObj[statKey.toUpperCase()] = statValue; // Use uppercase for consistency
//             });
//         }

//         return filteredAndRenamedObj;
//     });
// }

export function filterCols<T extends Record<string, any>>(arr: T[]): Record<string, any>[] {
    const newRushingColumns = [
        "PLAYER", "CLASS", "POS", "DATE", "SEASON",
        "TEAM", "OPP", "RES", "PERIOD_TYPE", "DATA_SOURCE", "PERIOD_NUMBER", "TOTAL"
    ];

    return arr.map((obj, index) => {
        let filteredAndRenamedObj: Record<string, any> = { ID: index + 1 };

        let tempData: Record<string, any> = {};

        // Support data-source fields even when not nested in `metadata`
        const rawDataSource =
            (obj as any)?.data_source 
        if (rawDataSource !== undefined) {
            tempData["DATA_SOURCE"] = rawDataSource;
        }

        if (obj.metadata && typeof obj.metadata === "object") {
            Object.entries(obj.metadata).forEach(([statKey, statValue]) => {
                tempData[statKey.toUpperCase()] = statValue;
            });
        }

        if (obj.stats && typeof obj.stats === "object") {
            Object.entries(obj.stats).forEach(([statKey, statValue]) => {
                tempData[statKey.toUpperCase()] = statValue;
            });
        }

        // add columns in the defined order but only if they exist
        newRushingColumns.forEach((col) => {
            if (tempData[col] !== undefined) {
                filteredAndRenamedObj[col] = tempData[col];
            }
        });

        // appending any remaining extra columns at the end
        Object.entries(tempData).forEach(([key, value]) => {
            if (!(key in filteredAndRenamedObj)) {
                filteredAndRenamedObj[key] = value;
            }
        });

        return filteredAndRenamedObj;
    });
}






